import ButtonSystem from './ButtonSystem';
import type { BaseButtonProps } from './types';

type PrimaryButtonProps = Omit<BaseButtonProps, 'variant'>;

/** Primary blue gradient button. */
const PrimaryButton = (props: PrimaryButtonProps) => <ButtonSystem {...props} variant="primary" />;

export default PrimaryButton;
